import * as React from "react";
import { createRoot, Root } from "react-dom/client";
// @ts-ignore 
import Page from "./page.tsx";
import reportWebVitals from './reportWebVitals';

import "./styles.scss";


let root: Root;
let rendered = false;
/**
 *
 */
const renderComponent = (jsx: React.ReactElement) => {
    if (!root) {
        root = createRoot(document.getElementById("root")!);
    }
    rendered && root.unmount();
    root.render(jsx);
    rendered = true;
};

(() => {
    const init = () => {
        renderComponent(<Page />);
        return true;
    };
    // console.log(document.readyState);
    (document.readyState === "complete" && init()) ||
        window.addEventListener("load", init, { once: true });
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
